/* @flow */

import { responseHasError } from '../diplomatico/reducers/helper';
import type { Action } from '../diplomatico/types';
import { enableInitializing } from 'initializable-reducer';
import _ from 'lodash';

const initialState = {};

function schoolGeneralCaligrafixBookHistory(state: Object = initialState, { type, payload }: Action) {
  switch (type) {
    case 'RESPONSE_SCHOOL_GENERAL_CALIGRAFIX_BOOK_HISTORY':
      if (responseHasError(payload)) {
        return state;
      }

      const { caligrafix_book_id, group_by } = payload._meta.payload.request;

      const newHistory = {
        [caligrafix_book_id]: {
          [group_by]: payload.body
        }
      };

      return _.assign({}, state, newHistory);
    default:
      return state;
  }
}

export {
  schoolGeneralCaligrafixBookHistory,
  initialState
};

export default enableInitializing(schoolGeneralCaligrafixBookHistory);
